import { InputTextarea } from "primereact/inputtextarea";
import "./style.scss";

const InputTextareaUI = ({ className = "", ...props }) => {
    return <InputTextarea {...props} className={`inputtextarea-ui ${className}`} />;
};

export default InputTextareaUI;
